var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 265 277",
    style: {
      enableBackground: "new 0 0 265 277"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#180305;}\n\t.st1{fill:#FF0000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Concepts"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NTC---A",
    transform: "translate(-2250.000000, -1881.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section-2---ALT",
    transform: "translate(0.000000, 1717.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_03-cloud",
    transform: "translate(2250.000000, 164.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st0",
    d: "M219,164H46c-25.3,0-45.9-20.5-46-45.9c0-25.4,20.5-46,45.8-46C51,49.4,71,33.3,94.2,33.2 c0.4,0,0.8,0,1.1,0c15.3-26.2,46.3-38.8,75.5-30.9s49.5,34.5,49.5,64.9c0,1.6-0.1,3.2-0.2,4.9c25.1,0.7,45,21.4,44.7,46.5 C264.5,143.7,244.1,164,219,164L219,164z M46,80C25,80,8,97,8,118s17,38.1,38,38.1h173c21,0,38-17,38-38.1S240,80,219,80h-3.3 c-1.1,0-2.2-0.5-3-1.4c-0.7-0.9-1.1-2-0.9-3.1c4-28.5-12.9-55.7-40.2-64.6s-57,3-70.6,28.3c-0.7,1.4-2.2,2.2-3.8,2.1 c-1.2-0.1-2.1-0.2-3.1-0.2c-20.6,0.1-38,15.2-41.1,35.5c-0.3,1.9-1.9,3.4-3.9,3.4H46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st0",
    d: "M215.4,244c-2.2,0-3.9-1.8-3.9-3.9v-25.4l-25.6-16.4c-1.1-0.7-1.8-2-1.8-3.3v-35.1 c0-2.2,1.7-3.9,3.9-3.9c2.2,0,3.9,1.8,3.9,3.9v32.9l25.6,16.4c1.1,0.7,1.8,2,1.8,3.3v27.5C219.3,242.2,217.5,244,215.4,244 L215.4,244z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1_",
    className: "st0",
    d: "M49.6,244c-2.2,0-3.9-1.8-3.9-3.9v-27.5c0-1.3,0.7-2.6,1.8-3.3L73,192.8v-32.9 c0-2.2,1.7-3.9,3.9-3.9c2.2,0,3.9,1.8,3.9,3.9V195c0,1.3-0.7,2.6-1.8,3.3l-25.6,16.4v25.4C53.5,242.2,51.7,244,49.6,244 L49.6,244z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2_",
    className: "st0",
    d: "M132.1,244c-2.2,0-4-1.8-4-3.9v-80.1c0-2.2,1.8-3.9,4-3.9s4,1.8,4,3.9v80.1 C136.1,242.2,134.3,244,132.1,244z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    className: "st1",
    d: "M216.1,276.8c-11,0-20-9-20-20c0-11,9-20,20-20s20,9,20,20 C236.1,267.8,227.1,276.8,216.1,276.8z M216.1,244.7c-6.7,0-12.1,5.4-12.1,12.1c0,6.7,5.4,12.1,12.1,12.1s12.1-5.4,12.1-12.1 C228.2,250.1,222.7,244.7,216.1,244.7L216.1,244.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2_",
    className: "st1",
    d: "M49.7,276.8c-11,0-20-9-20-20c0-11,9-20,20-20s20,9,20,20C69.7,267.8,60.7,276.8,49.7,276.8 L49.7,276.8z M49.7,244.7c-6.7,0-12.1,5.4-12.1,12.1c0,6.7,5.4,12.1,12.1,12.1s12.1-5.4,12.1-12.1 C61.8,250.1,56.3,244.7,49.7,244.7L49.7,244.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_",
    className: "st1",
    d: "M132.1,276.8c-11,0-20-9-20-20c0-11,9-20,20-20s20,9,20,20 C152.1,267.8,143.1,276.8,132.1,276.8L132.1,276.8z M132.1,244.7c-6.7,0-12.1,5.4-12.1,12.1c0,6.7,5.4,12.1,12.1,12.1 c6.7,0,12.1-5.4,12.1-12.1C144.2,250.1,138.7,244.7,132.1,244.7L132.1,244.7z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloud);
export default __webpack_public_path__ + "static/media/icon-cloud.45c3bb097850912b3021e30cfe4ee6ec.svg";
export { ForwardRef as ReactComponent };